<app-season-base-form-header translationKey="timeframe" [enableIcon]="enableIcon()" [(isDisabled)]="isDisabled" />
<form class="flex flex-col" [formGroup]="timeframe()">
    <div class="mb-6 max-w-[400px] flex flex-col gap-4">
        @for (language of [userLanguage()]; track language) {
            <sh-datepicker
                [formGroup]="timeframe()"
                formControlNameStart="startDate"
                formControlNameEnd="endDate"
                [label]="'seasons.season-creation.timeframe.timeframe' | translate"
                [locale]="datepickerLocale()"
                format="DDMMYYYY"
                separator="."
                [disabled]="isDisabled()"
                mandatory
                range
                [errorMessage]="
                    errorMessage('startDate') || errorMessage('endDate') || groupErrorMessage('dateRangeConflict')
                        | translate
                "
                [error]="isInvalid('startDate') || isInvalid('endDate') || hasGroupError('dateRangeConflict')"
            />
            <sh-datepicker
                formControlName="applicationDeadlineDate"
                [label]="'seasons.season-creation.timeframe.application-deadline-date' | translate"
                [locale]="datepickerLocale()"
                format="DDMMYYYY"
                separator="."
                [disabled]="isDisabled()"
                mandatory
                [errorMessage]="groupErrorMessage('endDateAfterApplicationDeadline') | translate"
                [error]="isInvalid('applicationDeadlineDate') || hasGroupError('endDateAfterApplicationDeadline')"
            />
        }
    </div>
</form>
